/**
 * Synapsy Widget - Configuration Parser
 * Prioridade: window.synapsyConfig > data-* attributes
 */

const DEFAULT_CONFIG = {
  position: process.env.WIDGET_POSITION || "right",
  iframeUrl: process.env.WIDGET_IFRAME_URL || "http://localhost:5170",
  debug: process.env.WIDGET_DEBUG === "true" || false,
  // allowedOrigins já vem como array parseado do build (rollup replace)
  allowedOrigins: process.env.VITE_WIDGET_ALLOWED_ORIGINS || ["*"],
  // Exibe o "X" de dispensar o balão. Sobreponível por data-bubble-closable
  // ou window.synapsyConfig.
  bubbleClosable: true,
  // Anima a entrada do launcher/balão (1x por sessão). Sobreponível por
  // data-entrance-animation ou window.synapsyConfig.
  entranceAnimation: true,
};

/**
 * Parseia configuração do widget
 * @param {HTMLScriptElement} scriptElement - Script tag do widget
 * @returns {Object} Configuração parseada
 */
export function parseConfig(scriptElement) {
  // Ler data-* attributes
  const rawEntrance = scriptElement.getAttribute("data-entrance-animation");
  const rawClosable = scriptElement.getAttribute("data-bubble-closable");
  const dataConfig = {
    position: scriptElement.getAttribute("data-position"),
    debug: scriptElement.getAttribute("data-debug") === "true",
    // ausente → null (mantém default true); "false" → false; resto → true
    entranceAnimation: rawEntrance === null ? null : rawEntrance !== "false",
    bubbleClosable: rawClosable === null ? null : rawClosable !== "false",
  };

  // Ler window.synapsyConfig (prioridade maior)
  const windowConfig = window.synapsyConfig || {};

  // Merge: windowConfig > dataConfig > DEFAULT_CONFIG
  const config = {
    ...DEFAULT_CONFIG,
    ...Object.fromEntries(
      Object.entries(dataConfig).filter(
        ([_, v]) => v !== null && v !== undefined,
      ),
    ),
    ...Object.fromEntries(
      Object.entries(windowConfig).filter(
        ([_, v]) => v !== null && v !== undefined,
      ),
    ),
  };

  if (config.debug) {
    console.log("[Synapsy Widget] Configuração parseada:", config);
  }

  return config;
}
